import Plyr from 'plyr';
import Component from '../Component';

class Player extends Component {
  constructor(options) {
    super(options);
    this.video = this.root.querySelector('.player');
  }

  attachEventListeners() {
    new Plyr(this.video, {
      youtube: {
        playsinline: 1
      }
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default Player;
